// @flow

import React, { Component } from 'react'

type Props = {
  color?: string,
}

export default class BouncingLoader extends Component<Props> {
  render() {
    const { color } = this.props
    return (
      <div className="bouncing-loader">
        <div style={{ backgroundColor: color }}></div>
        <div style={{ backgroundColor: color }}></div>
        <div style={{ backgroundColor: color }}></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Loader/BouncingLoader.js